import { Grid } from '@material-ui/core';
import React from 'react';
import useStyles from '../../styles/useStyles';
import DocumentLinkManagementGrid from './components/DocumentLinkManagement/DocumentLinkManagementGrid';

interface ConfigurationDocumentLinkProps {}

const ConfigurationDocumentLink: React.FC<ConfigurationDocumentLinkProps> = ({}) => {
    const classes = useStyles();

    return (
        <Grid style={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item xs={12} className={classes.syncLogsGrid}>
                <DocumentLinkManagementGrid />
            </Grid>
        </Grid>
    );
};

export default ConfigurationDocumentLink;
